var map = {
	"./en.json": "grrI",
	"./ja.json": "RP/V",
	"./modules/jfd/ja.json": "lWRo",
	"./modules/ymk/ja.json": "0jS9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "qKhH";


//////////////////
// WEBPACK FOOTER
// ./src/app/lang ^\.\/.*\.json$
// module id = qKhH
// module chunks = 120